import ClubFinancialAccountingDatevExport from '../dto/ClubFinancialAccountingDatevExport';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubFinancialAccountingExportRepository {

    static getDatevExports(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/financial-accounting/datev-exports`)
                .then(response => resolve(response.data.data.map(data => ClubFinancialAccountingDatevExport.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createDatevExport(clubId, bookingPeriodMonth, bookingPeriodYear, invoicePeriodStart, invoicePeriodEnd) {
        const url = `/club/clubs/${clubId}/financial-accounting/datev-exports?dateRange=${invoicePeriodStart}:${invoicePeriodEnd}`;
        const data = {bookingPeriodMonth: bookingPeriodMonth, bookingPeriodYear: bookingPeriodYear};
        return new Promise((resolve, reject) => {
            axios
                .post(url, data)
                .then(response => resolve(response))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
